import { render, staticRenderFns } from "./Ayuda.vue?vue&type=template&id=6d9dce50&scoped=true&"
import script from "./Ayuda.vue?vue&type=script&lang=js&"
export * from "./Ayuda.vue?vue&type=script&lang=js&"
import style0 from "./Ayuda.vue?vue&type=style&index=0&id=6d9dce50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9dce50",
  null
  
)

export default component.exports